import { type FC } from 'react';
import {
  UiHStack,
  UiIconWarningDiamond,
  UiModal,
  UiModalBody,
  UiModalCloseButton,
  UiModalContent,
  UiModalOverlay,
  UiStack,
  UiText,
} from '@/lib/ui';
import BaseMessageBarError from '@/base/MessageBar/Error';

interface EmptyWarningModalProps {
  isOpen: boolean
  onClose: () => void
  message: string
}

const EmptyWarningModal: FC<EmptyWarningModalProps> = ({
  isOpen = false,
  onClose,
  message,
}) => {
  return (
    <UiModal isOpen={isOpen}
      onClose={onClose}
      size={{
        base: 'md',
        md: 'md',
      }}
      motionPreset={'scale'}
      closeOnEsc
      closeOnOverlayClick
      isCentered
    >
      <UiModalOverlay />
      <UiModalContent>
        <UiModalCloseButton />
        <UiModalBody py={8} px={{base: 4, lg: 8}}>
          <BaseMessageBarError>
            {message}
            {/*You must add a registration type to your cart to continue.*/}
          </BaseMessageBarError>
          {/*<UiHStack justifyContent={'center'} alignItems={'center'}>*/}
          {/*  <UiIconWarningDiamond size={'3xl'} color={'yellow.400'} />*/}
          {/*  <UiText fontSize='sm' fontWeight="bold" textAlign="center">*/}
          {/*    You must add a Registration type to your cart to continue*/}
          {/*  </UiText>*/}
          {/*</UiHStack>*/}
        </UiModalBody>
      </UiModalContent>
    </UiModal >
  );
};

export default EmptyWarningModal;
